<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    size="lg"
    no-close-on-esc
    no-close-on-backdrop
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <b-row class="mb-1">
        <b-col>
          <b-input
            autofocus
            placeholder="Digite o N° do CTE"
            type="text"
            v-model="form.cte"
          ></b-input>
          <!-- <span>Qtde. caracteres código de barra: {{ qtdCaracteres() }}</span> -->
        </b-col>
        <b-col>
          <b-btn :disabled="loading" @click="onScan()" variant="secondary"
            >Buscar CTE</b-btn
          >
          <b-btn
            class="ml-1"
            :disabled="loading"
            @click="onSeach()"
            variant="secondary"
            >Procurar</b-btn
          >
        </b-col>
        <b-col>
          <label
            >Total de trechos selecionados: {{ this.trechos.length }}</label
          >
        </b-col>
        <b-col>
          <label
            >Valor total de trechos selecionados: R$:
            {{ formatNumber(this.trechos_valor) }}</label
          >
        </b-col>
      </b-row>
    </form>
    <div class="loadingDataPosition">
      <div class="loadingData" v-if="loading"></div>
      <vuetable
        ref="vuetable"
        :api-mode="false"
        :data="doctransp"
        :fields="fields"
        :css="css"
        :append-params="moreParams"
        track-by="peduncatr_id"
        pagination-path=""
        @vuetable:load-error="onError"
        @vuetable:pagination-data="onPaginationData"
        @vuetable:loaded="onLoaded"
        detail-row-component="expedicaocargaform-detalhes"
        @vuetable:cell-clicked="onDetail"
      >
        <template slot="dt_emissao" slot-scope="props">
          <span>{{ formatDate(props.rowData.dt_emissao) }}</span>
        </template>
        <!-- <template slot="vlr_cte" slot-scope="props">
          <span v-if="props.rowData.fatura_despesa_doc.length != 0 && 
            props.rowData.fatura_despesa_doc[0].doc_transp != null">{{
            formatNumber(
              props.rowData.fatura_despesa_doc[0].doc_transp.doc_transp_docfis
                .doc_fiscal.carga_doc.doc_carga_doc.doc.vlr_prestacao
            )
          }}</span>
        </template> -->
      </vuetable>
    </div>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="onStore()" variant="secondary"> Associar </b-btn>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
      </div>
    </div>
    <AssociarDocumentoDespesaModalBusca ref="associardocumentodespesabusca" />
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";
import accounting from "accounting";
import Vuetable from "../components/Vuetable";
import moment from "moment";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import AssociarDocumentoDespesaModalBusca from "./AssociarDocumentoDespesaModalBusca.vue";

import { formatCNPJFromParts } from "../utils";

export default {
  components: {
    AvisoErros,
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    AssociarDocumentoDespesaModalBusca,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      permite_digitar: false,
      loading: false,
      isDisabled: true,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      errors_array: [],
      doctransp: [],
      trechos: [],
      cd_barra: "",
      form: new Form({
        cte: "",
        cte_id: "",
        trechos: [],
      }),
      helpForm: new Form({ search: "", peduncatr_id: "", carga_id: "" }),
      fields: [
        {
          name: "num_doc",
          title: "N° CTE",
        },
        {
          name: "serie",
          title: "Serie",
        },
        {
          name: "vlr_cte",
          title: "Valor Cte",
        },
        {
          name: "cnpj",
          title: "CNPJ - Emitente",
        },
        {
          name: "razao_social",
          title: "Razão social - Emitente",
        },
        {
          name: "__slot:dt_emissao",
          title: "Data Emissão",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("popula-grid", (eventData) => this.reciveData(eventData));
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.docfisttra_id);
      }
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    reciveData(data) {
      console.log("data");
      console.log(data);
      this.doctransp.push({
        num_doc: data.num_doc,
        serie: data.serie,
        cnpj: data.doc_transp_partes_env.emi_cnpj,
        vlr_cte: this.formatNumber(data.doc_transp_vlr_prestacao.vlr_receber),
        razao_social: data.doc_transp_partes_env.emi_nome,
        dt_emissao: data.dt_emissao,
        doctransp_id: data.doctransp_id,
      });
      this.form.cte_id = this.doctransp[0].doctransp_id;
      this.$refs.vuetable.reload();
    },
    onCreate(data, vlr_total_trechos) {
      this.permite_digitar = this.checkPermissionBip();
      this.errors_array = "";
      this.errors_array = [];
      this.doctransp = [];
      this.trechos = [];
      this.isDisabled = true;
      this.loading = false;
      this.modal_titulo = "Associar Documento";
      this.modal_botao = "Associar";
      this.modal_acao = "i";
      this.form.reset();
      this.trechos = data;
      this.trechos_valor = vlr_total_trechos;
      this.form.trechos = this.trechos;
      this.$refs.modal_form.show();
    },
    onScan() {
      this.errors_array = [];
      this.doctransp = [];
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/associardocumentodespesa/checkdoctransp")
        .then((response) => {
          new ReturnApi(response, this);
          //   response.data.forEach((item, i) => {
          //       this.notas_fiscais.push({
          //         num_fiscal: item.num_fiscal,
          //     });
          //   });
          this.doctransp.push({
            num_doc: response.num_doc,
            serie: response.serie,
            vlr_cte: this.formatNumber(response.doc_transp_vlr_prestacao.vlr_receber),
            cnpj: response.doc_transp_partes_env.emi_cnpj,
            razao_social: response.doc_transp_partes_env.emi_nome,
            dt_emissao: response.dt_emissao,
            doctransp_id: response.doctransp_id,
          });
          this.form.cte_id = this.doctransp[0].doctransp_id;
          // Vue.nextTick(() => this.$refs.vuetable.reload());
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/associardocumentodespesa/associar")
        .then((response) => {
          new ReturnApi(response, this);
          this.$parent.$refs.vuetable.selectedTo = [];
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onSeach() {
      this.doctransp = [];
      this.$refs.associardocumentodespesabusca.onBuscarDocFiscal();
    },
    onRowClass(data, index) {
      return data.qtde_bipada == data.qtde_total
        ? "table-success"
        : "table-warning";
    },
    checkPermissionBip() {
      return this.getPermissionFw("expedicao.digitaretiqueta"); //
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.docfis_id);
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },

    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    qtdCaracteres() {
      return this.cd_barra.length;
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY/MM/DD").format(fmt);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>